import React from "react";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import projectData from "../../projectData";
import MyNavbar from "../Home/MyNavbar/MyNavbar";
import ProjectSnapshot from "../Shared/ProjectSnapshot/ProjectSnapshot";
import ProjectDetailsModal from "../Shared/Modals/ProjectDetails";

const Projects = () => {
  const [projectsData] = useState(projectData);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [project, setProject] = useState({});
  function openModal(pd) {
    setIsOpen(true);
    setProject(pd);
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <>
    <MyNavbar></MyNavbar>
      <section style={{ marginTop: "6.5rem" }} className="projects pb-3">
        <div className="container">
          <h2 className="title text-center">My Projects</h2>
          
          <div className="portfolio-note mx-auto" data-aos="fade-up">
              <FontAwesomeIcon icon={faInfoCircle} className="portfolio-note-icon" />
              <div className="portfolio-note-content">
                  Most of these projects feature my earlier work, primarily developed in 2021. They serve as a foundational snapshot of my coding journey and demonstrate my experience in building complete applications.
              </div>
          </div>

          <div className="row row-cols-1 row-cols-md-3 g-4 mt-2 mb-2">
            {projectsData.map((project) => (
              <div key={project.id} className="col mt-4">
                <div
                  onClick={() => openModal(project)}
                  title="View Project Details"
                  className="card h-100 project-card overflow-hidden"
                  data-aos="fade-down"
                  data-aos-delay="50"
                  data-aos-duration="1000"
                  style={{ cursor: "pointer", backgroundColor: "var(--bg-secondary)", border: "1px solid var(--border-subtle)", borderRadius: "var(--radius-md)" }}
                >
                  <div className="project-snapshot-wrapper" style={{ height: "200px" }}>
                    <ProjectSnapshot url={project.link} title={project.title} />
                  </div>
                  <div className="card-footer bg-transparent border-0 py-3">
                    <h4 className="title__color text-center m-0">{project.title}</h4>
                  </div>
                </div>
              </div>
            ))}
            <ProjectDetailsModal
              key={project.id}
              modalIsOpen={modalIsOpen}
              closeModal={closeModal}
              project={project}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;
